import React, { createContext, useContext, useState, ReactNode } from 'react';
import { useXR } from '@react-three/xr';

// Create a context for the XR state
const XRStoreContext = createContext<any>(null);

// Hook to use the XR store
export const useXRStore = () => {
  const store = useContext(XRStoreContext);
  if (!store) {
    throw new Error('useXRStore must be used within an XRProvider');
  }
  return store;
};

interface XRProviderProps {
  children: ReactNode;
}

// Provider component that creates and provides the XR state
export const XRProvider: React.FC<XRProviderProps> = ({ children }) => {
  // Create a simple store with enter methods
  const store = {
    enterVR: () => {
      // This will be handled by the VRButton from @react-three/xr
      console.log('Attempting to enter VR');
    },
    enterAR: () => {
      // This will be handled by the ARButton from @react-three/xr
      console.log('Attempting to enter AR');
    }
  };

  return (
    <XRStoreContext.Provider value={store}>
      {children}
    </XRStoreContext.Provider>
  );
}; 